export default __webpack_public_path__ + "static/media/casual-kid.239d7a69.jpg";